import type { Channel } from '../types/Channel';

interface PlayerHeaderProps {
  channel: Channel;
}

export default function PlayerHeader({ channel }: PlayerHeaderProps) {
  return (
    <header className="flex items-center gap-4 px-6 py-4 bg-neutral-900/80 backdrop-blur-sm border-b border-white/5">
      <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-emerald-500/30">
        <img
          src={channel.logo}
          alt={channel.name}
          className="w-full h-full object-cover"
        />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h2 className="text-white font-semibold text-base truncate">
            {channel.name}
          </h2>
          {channel.isLive && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-red-500/20 text-red-400 text-xs font-semibold whitespace-nowrap">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
              LIVE
            </span>
          )}
        </div>
        <div className="flex items-center gap-3 mt-0.5">
          <span className="text-neutral-400 text-xs">{channel.frequency}</span>
          <span className="text-neutral-600 text-xs">·</span>
          <span className="text-neutral-400 text-xs capitalize">
            {channel.playbackMode === 'audio' ? 'Audio Stream' : 'AV Stream'}
          </span>
          <span className="text-neutral-600 text-xs">·</span>
          <span className="text-neutral-400 text-xs">
            {channel.listeners.toLocaleString()} listening
          </span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-emerald-500 shadow-[0_0_6px_rgba(16,185,129,0.5)]" />
        <span className="text-emerald-400 text-xs font-medium whitespace-nowrap">On Air</span>
      </div>
    </header>
  );
}